import { ConfigurationStatus } from "@/api/dtos";
import TrialContext from "@/contexts/data/TrialContext";
import TrialsContext from "@/contexts/data/TrialsContext";
import { LinkContext } from "@/contexts/layouts/LinkContext";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Divider, Menu, MenuItem, styled } from "@mui/material";
import { FC, MouseEvent, useContext, useMemo, useState } from "react";
import { Link as RouteLink } from 'react-router-dom';

const StyledDivider = styled(Divider)(({ theme}) => ({
    margin: `0 !important`
}));

const NavigationTrialSelector: FC = () => {
    const { createTrialLink, trialLinkEnabled } = useContext(LinkContext);
    
    const { data: trial} = useContext(TrialContext);
    const { data: trials} = useContext(TrialsContext);
    
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleMenu = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const list = useMemo(() => {
        return trials?.filter(x => !!x.status && x.status !== ConfigurationStatus.Disabled)?.map((x, i, a) => {
            return (
                [
                    <MenuItem key={x.oid} component={RouteLink} to={createTrialLink(x)} onClick={handleClose}>{x.name}</MenuItem>,
                    i < (a.length - 1) ? <StyledDivider key={`${x.oid}-divider`} /> : null
                ]
            );
        })
    }, [trials, createTrialLink, handleClose])

    if (!trialLinkEnabled || !trial) {
        return null;
    }
    
    return (
        <>
            <Button
                id="btn-trials"
                color="inherit"
                aria-label="trial selection"
                aria-controls="menu-trials"
                aria-haspopup="true"
                sx={{mr: 2}}
                onClick={handleMenu}
                endIcon={<FontAwesomeIcon icon={faChevronDown} fixedWidth style={{fontSize: '1rem'}} />}
            >
                {
                    trial ?
                        trial.name :
                        'No Trial Selected'
                }
            </Button>
            <Menu
                id="menu-trials"
                anchorEl={anchorEl}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                open={anchorEl?.id === 'btn-trials'}
                onClose={handleClose}
                MenuListProps={{
                    disablePadding: true
                }}
            >
                {list}
            </Menu>
        </>
    )
}

export default NavigationTrialSelector;